import React from 'react';
import { Section } from './ui/Section';
import { X, Check } from 'lucide-react';
export function NewComparison() {
  return <Section className="bg-cream-warm py-24" data-id="element-90">
      <div className="max-w-4xl mx-auto" data-id="element-91">
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-forest-deep text-center mb-12" data-id="element-92">
          ¿Cómo resuelve esto los problemas cotidianos?
        </h2>

        <div className="grid md:grid-cols-2 gap-0 rounded-2xl overflow-hidden shadow-lg border border-sage-mist/30" data-id="element-93">
          {/* Sin Hogar Natural */}
          <div className="bg-white p-8 md:p-10" data-id="element-94">
            <h3 className="text-xl font-bold text-forest-deep mb-6 flex items-center gap-2" data-id="element-95">
              <span className="w-8 h-8 rounded-full bg-red-100 text-red-500 flex items-center justify-center shrink-0" data-id="element-96">
                <X className="w-5 h-5" data-id="element-97" />
              </span>
              Sin Hogar Natural
            </h3>
            <ul className="space-y-5" data-id="element-98">
              <li className="flex items-start gap-3 text-forest/80" data-id="element-99">
                <X className="w-5 h-5 text-red-400 shrink-0 mt-0.5" data-id="element-100" />
                <span data-id="element-101">Buscar en Google a las apuradas.</span>
              </li>
              <li className="flex items-start gap-3 text-forest/80" data-id="element-102">
                <X className="w-5 h-5 text-red-400 shrink-0 mt-0.5" data-id="element-103" />
                <span data-id="element-104">Encontrar información contradictoria.</span>
              </li>
              <li className="flex items-start gap-3 text-forest/80" data-id="element-105">
                <X className="w-5 h-5 text-red-400 shrink-0 mt-0.5" data-id="element-106" />
                <span data-id="element-107">No saber qué hacer realmente.</span>
              </li>
              <li className="flex items-start gap-3 text-forest/80" data-id="element-108">
                <X className="w-5 h-5 text-red-400 shrink-0 mt-0.5" data-id="element-109" />
                <span data-id="element-110">Perder tiempo valioso.</span>
              </li>
            </ul>
          </div>

          {/* Con Hogar Natural */}
          <div className="bg-forest-mist p-8 md:p-10 relative" data-id="element-111">
            <div className="absolute top-0 right-0 w-full h-1 bg-moss" data-id="element-112" />
            <h3 className="text-xl font-bold text-forest-deep mb-6 flex items-center gap-2" data-id="element-113">
              <span className="w-8 h-8 rounded-full bg-moss text-white flex items-center justify-center shrink-0" data-id="element-114">
                <Check className="w-5 h-5" data-id="element-115" />
              </span>
              Con Hogar Natural
            </h3>
            <ul className="space-y-5" data-id="element-116">
              <li className="flex items-start gap-3 text-forest-deep font-medium" data-id="element-117">
                <Check className="w-5 h-5 text-moss shrink-0 mt-0.5" data-id="element-118" />
                <span data-id="element-119">Abrís la guía específica.</span>
              </li>
              <li className="flex items-start gap-3 text-forest-deep font-medium" data-id="element-120">
                <Check className="w-5 h-5 text-moss shrink-0 mt-0.5" data-id="element-121" />
                <span data-id="element-122">Encontrás la respuesta exacta.</span>
              </li>
              <li className="flex items-start gap-3 text-forest-deep font-medium" data-id="element-123">
                <Check className="w-5 h-5 text-moss shrink-0 mt-0.5" data-id="element-124" />
                <span data-id="element-125">Seguís los pasos detallados.</span>
              </li>
              <li className="flex items-start gap-3 text-forest-deep font-medium" data-id="element-126">
                <Check className="w-5 h-5 text-moss shrink-0 mt-0.5" data-id="element-127" />
                <span data-id="element-128">Actuás rápido y con confianza.</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </Section>;
}